import React from 'react'
import { Container } from './styles/filter'

export default function FilterWrapper({ children, ...props }) {
    return <Container {...props}>{children}</Container>
}
